module.exports = __webpack_public_path__ + "img/1-C-resources.caec8151.png";